export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8178.8e313cf6.jpg";